<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="账号：" prop="username">
              <el-input v-model="ruleForm.username"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="密码：" prop="password">
              <el-input v-model="ruleForm.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">保存</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyInfo } from "@/api/systemApi";
export default {
  props: ["editData"],
  data() {
    return {
      ruleForm: {
        name: "",
        username: "",
        password: "",
        phone: "",
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        username: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入11位有效手机号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (this.editData) {
      this.ruleForm = this.editData;
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.nickname = this.ruleForm.name;
          this.$emit("submit", this.ruleForm, false);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .remark {
      float: left;
      margin-left: -75px;
      color: #999;
    }
  }
  /deep/.el-button {
    width: 100px;
  }
  /deep/.el-input__inner {
    width: 260px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/usermanage/components/editModel.vue